import {
  anonymousUser,
  b64DecodeUnicode,
  ReducedUserTokenState,
  reduceUserSegment,
  UserTokenState,
} from 'lib/utils/parseUser';

const parseUserV2 = (user_token?: string): ReducedUserTokenState => {
  const token = user_token;

  if (!token) return anonymousUser;

  try {
    const user: UserTokenState = JSON.parse(
      b64DecodeUnicode(token.split('.')[1].replace('-', '+').replace('_', '/')),
    );

    return {
      auth_token: user.auth_token || null,
      id: user.id || null,
      id_digest: user.id_digest || null,
      external_id: user.external_id || null,
      package_name: user.package_name || null,
      email: user.email || null,
      first_name: user.first_name || null,
      last_name: user.last_name || null,
      role: user.role || 'guest',
      segment: user.segment || 'anonymous',
      reducedSegment: reduceUserSegment(user.segment),
      idDigest: user.id_digest || '',
      cancelled_memberships: user.cancelled_memberships ?? null,
      active_memberships: user.active_memberships ?? null,
      active_cds_membership: user.active_cds_membership ?? false,
      account_auth_type: user.account_auth_type ?? null,
      linked_providers: user.linked_providers ?? null,
      auth_method: user.auth_method ?? null,
    };
  } catch {
    return anonymousUser;
  }
};

type NonNullable<T> = T extends null | undefined ? never : T;

export type PruneNullish<T> = {
  [K in keyof T]?: NonNullable<T[K]>;
};

export function pruneNullishValues<T>(obj: T): PruneNullish<T> {
  if (Array.isArray(obj)) {
    return obj.map(pruneNullishValues) as unknown as PruneNullish<T>;
  }
  if (obj && typeof obj === 'object') {
    const result: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(obj)) {
      if (v != null && v != undefined) {
        result[k] =
          v && typeof v === 'object'
            ? pruneNullishValues(v as Record<string, unknown>)
            : v;
      }
    }
    return result as PruneNullish<T>;
  }
  return obj as PruneNullish<T>;
}

export default parseUserV2;
